import React, { useState } from 'react';
import '../css/problem-construct.css';

import { SubmitBar } from '../components/submit-bar';
import { APP_CFG } from '../appcfg';
import {
  moveOnToNextPage,
  submitResponse,
  showConfetti
} from '../redux/actions/ui';

import {
  Panel,
  setSideBarCorrect,
  setSideBarOpenPanel,
  setSideBarSecondTry,
  setSideBarIncorrect
} from '../sidebar-state';
import { getCorrectElement, getGeneralHint, getReviewMessage } from '../components/side-bar';
import { ConstructContent } from '../page-content/construct-content';
import {
  ProblemStage,
  ConstructData,
  ProblemConstructComp,
  ITSEventType
} from 'its-pages';
import { useAppDispatch, useAppSelector } from '../redux/hooks';

/*
This is only for P6 problems
*/


interface Props {
  constructData: ConstructContent;
}

const ProblemConstruct = (props: Props) => {
  const [stage, setStage] = useState(ProblemStage.CollectInput);
  const [firstTryScore, setFirstTryScore] = useState(0);
  const correctAnswerStreak = useAppSelector((state) => state.progression.correctAnswerStreak);
  const dispatch = useAppDispatch();

  const {
    constructData: constructContent,
  } = props;

  const pageData = constructContent.pageData as ConstructData;
  const { options, hints, problemQuality } = pageData;

  const onSubmit = () => {
    const {
      answeredCorrectly,
      answeredIncorrectly,
      enoughAnsweredCorrectly,
      score
    } = pageData.constructScore;

    const isProblemCorrectFn = (): boolean => {
      return score === 1;
    };

    const resetOptions = (): void => {
      if (APP_CFG.autoResetButtons) {
        options.forEach((options): void => {
          options.isSelected = false;
        });
      }
    };

    const gotoShowResult = () => {
      dispatch(submitResponse());
      setStage(ProblemStage.ShowResult);
    };

    const gotoSecondTry = () => {
      setStage(ProblemStage.SecondTry);
      setFirstTryScore(score);
      pageData.recordEvent(ITSEventType.firstTryWrong);
      resetOptions();
    };

    const getSecondTryHint = () => {
      return (
        <div>
          <h3>I&apos;m sorry, that is not quite what we are looking for.</h3>
          <p>
            {answeredIncorrectly > 0
              ? (answeredCorrectly > 0 ? 'Some' : 'All') +
                ' of your selections are incorrect'
              : ''}
            {answeredIncorrectly > 0 &&
            !enoughAnsweredCorrectly &&
            answeredCorrectly > 0
              ? ' and t'
              : !enoughAnsweredCorrectly && answeredCorrectly > 0
              ? 'T'
              : ''}
            {!enoughAnsweredCorrectly && answeredCorrectly > 0
              ? 'here are more correct answers'
              : ''}
            .
          </p>
          { getGeneralHint(hints, problemQuality) }
        </div>
      );
    };

    const getReviewText = (): JSX.Element => {
      return (
        <div>
          { getReviewMessage(correctAnswerStreak, score > firstTryScore) }
          { getGeneralHint(hints, problemQuality) }
        </div>
      );
    };

    if (stage === ProblemStage.ShowResult) {
      dispatch(moveOnToNextPage());
    } else if (isProblemCorrectFn()) {
      dispatch(showConfetti(true));
      setSideBarCorrect(getCorrectElement(pageData.seed));
      gotoShowResult();
    } else if (stage === ProblemStage.CollectInput) {
      setSideBarSecondTry(getSecondTryHint());
      gotoSecondTry();
    } else if (stage === ProblemStage.SecondTry) {
      setSideBarIncorrect(getReviewText());
      gotoShowResult();
    } else {
      dispatch(moveOnToNextPage());
    }
  };

  const secondTry = stage === ProblemStage.SecondTry;
  const showResult = stage === ProblemStage.ShowResult;

  const onReviewed = () => {
    if (showResult) {
      setSideBarOpenPanel(Panel.None);
    }
  };

  return (
    <div className='Problem ProblemConstruct'>
      <ProblemConstructComp
        pageData={pageData}
        stage={stage}
        onReviewed={onReviewed}
      />
      <SubmitBar
        onSubmit={onSubmit}
        buttonText={
          secondTry ? 'Try Again' : showResult ? 'Continue' : 'Submit'
        }
        disabledTip={
          showResult
            ? undefined
            : secondTry
            ? 'Change your selection'
            : 'Make a selection'
        }
        buttonClass={'SubmitBarButton'}
      />
    </div>
  );
};

export const Construct = ProblemConstruct;
export default Construct;
